export default __webpack_public_path__ + "static/media/erc20.6540b4f4.svg";